/**
 * @generated SignedSource<<675e4bb9cc556d38cfd8e1177b64c6ef>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VocabularyDetailExamplesQuery$variables = {
  id: string;
};
export type VocabularyDetailExamplesQuery$data = {
  readonly node: {
    readonly exampleSentences?: ReadonlyArray<string>;
  } | null | undefined;
};
export type VocabularyDetailExamplesQuery = {
  response: VocabularyDetailExamplesQuery$data;
  variables: VocabularyDetailExamplesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exampleSentences",
      "storageKey": null
    }
  ],
  "type": "VocabularyItem",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VocabularyDetailExamplesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "VocabularyDetailExamplesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "87ccb19613d31fdac106e6b324d85c21",
    "id": null,
    "metadata": {},
    "name": "VocabularyDetailExamplesQuery",
    "operationKind": "query",
    "text": "query VocabularyDetailExamplesQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on VocabularyItem {\n      exampleSentences\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d75f9664dcae729ab55c7e993bfc8d3";

export default node;
